/* NOSEE — landing interactions. Idempotent (safe if included more than once). */
(function () {
  if (window.__noseeInit) return;
  window.__noseeInit = true;

  var money = function (cents, fmt) {
    var amt = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{amount}') !== -1) return fmt.replace('{amount}', amt);
    return 'JOD' + amt;
  };

  function norm(s) {
    return (s || '').toString().replace(/\s+/g, ' ').trim();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initOffers();
    initGallery();
    initAccordion();
    initSticky();
    initCountdown();
  });

  function initOffers() {
    var root = document.querySelector('[data-nosee-offers]');
    var form = document.querySelector('[data-nosee-form]');
    if (!root) return;

    var variants = [];
    var vNode = document.getElementById('nosee-variants');
    if (vNode) { try { variants = JSON.parse(vNode.textContent); } catch (e) {} }

    if (!variants.length) {
      var anyVariantsNode = document.querySelector('script[type="application/json"][id^="nosee-variants"]');
      if (anyVariantsNode) { try { variants = JSON.parse(anyVariantsNode.textContent); } catch (e) {} }
    }

    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-color]'));
    var cfgNode = form || root;
    var deliveryFee = parseInt(cfgNode.getAttribute('data-delivery-cents') || root.getAttribute('data-delivery-cents') || '0', 10);
    var moneyFmt = cfgNode.getAttribute('data-money-format') || root.getAttribute('data-money-format') || 'JOD{amount}';

    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var cta = form ? form.querySelector('[data-nosee-cta]') : document.querySelector('[data-nosee-cta]');

    var state = { pack: null, color: null, priceCents: 0, free: false };

    function currentColor() {
      var active = swatches.filter(function (s) { return s.classList.contains('is-active'); })[0];
      return active ? active.getAttribute('data-color') : null;
    }

    function resolveVariant() {
      if (!variants.length) return null;
      if (variants.length === 1) return variants[0];
      if (!state.pack) return variants[0];
      var color = currentColor();
      var packWanted = norm(state.pack);
      var match = variants.filter(function (v) {
        var packOk = norm(v.option1) === packWanted;
        var colorOk = !color || norm(v.option2) === norm(color);
        return packOk && colorOk;
      })[0];
      if (match) return match;
      match = variants.filter(function (v) { return norm(v.option1) === packWanted; })[0];
      if (match) return match;
      return variants.filter(function (v) { return v.available !== false; })[0] || variants[0];
    }

    function updateTotal() {
      var total = state.priceCents + (state.free ? 0 : deliveryFee);
      var el = document.querySelector('[data-nosee-total]');
      if (el) el.textContent = money(total, moneyFmt);
      var sticky = document.querySelector('[data-nosee-sticky-price]');
      if (sticky) sticky.textContent = money(total, moneyFmt);
    }

    function syncVariant() {
      var v = resolveVariant();
      if (idInput) idInput.value = v ? v.id : '';
      if (cta) {
        if (variants.length && !v) {
          cta.setAttribute('disabled', 'disabled');
        } else {
          cta.removeAttribute('disabled');
        }
      }
    }

    function selectOffer(el) {
      offers.forEach(function (o) { o.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      state.pack = el.getAttribute('data-pack') || null;
      state.priceCents = parseInt(el.getAttribute('data-price-cents') || '0', 10);
      state.free = el.getAttribute('data-free-shipping') === 'true';
      offers.forEach(function (o) {
        var c = o.querySelector('.nosee-colors');
        if (c) c.classList.toggle('is-on', o === el && c.getAttribute('data-has-colors') === 'true');
      });
      updateTotal();
      syncVariant();
    }

    offers.forEach(function (el) {
      el.addEventListener('click', function () { selectOffer(el); });
      el.setAttribute('tabindex', '0');
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOffer(el); }
      });
    });

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        syncVariant();
      });
    });

    var pre = offers.filter(function (o) { return o.getAttribute('data-default') === 'true'; })[0] || offers[0];
    if (swatches[0]) swatches[0].classList.add('is-active');
    if (pre) {
      selectOffer(pre);
    } else if (form && idInput && variants.length) {
      var v = resolveVariant();
      if (v) idInput.value = v.id;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validateForm(form)) return;

        if ((!idInput || !idInput.value) && variants.length) {
          var fallback = resolveVariant();
          if (fallback && idInput) idInput.value = fallback.id;
        }

        if (!idInput || !idInput.value) {
          var errBox2 = form.querySelector('[data-nosee-order-error]');
          if (errBox2) {
            errBox2.textContent = 'الرجاء اختيار عرض قبل إتمام الطلب';
            errBox2.style.display = 'block';
          }
          return;
        }

        var errBox = form.querySelector('[data-nosee-order-error]');
        if (errBox) { errBox.style.display = 'none'; errBox.textContent = ''; }
        if (cta) { cta.setAttribute('disabled', 'disabled'); cta.dataset.origLabel = cta.dataset.origLabel || cta.textContent; cta.textContent = form.getAttribute('data-loading-text') || cta.textContent; }

        var settled = false;
        var resetButton = function (message) {
          if (settled) return;
          settled = true;
          if (watchdog) clearTimeout(watchdog);
          if (cta) { cta.removeAttribute('disabled'); cta.textContent = cta.dataset.origLabel; }
          if (message && errBox) { errBox.textContent = message; errBox.style.display = 'block'; }
        };
        var watchdog = setTimeout(function () {
          resetButton('تعذّر الاتصال — إذا كنت تعاين المتجر من داخل محرر Shopify، جرّب فتح المعاينة (Preview) في تبويب منفصل بدلاً من ذلك.');
        }, 10000);

        var nameEl = form.querySelector('input[name="properties[الاسم الكامل]"]');
        var phoneEl = form.querySelector('input[name="properties[رقم الهاتف]"]');
        var addressEl = form.querySelector('input[name="properties[العنوان]"]');

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: parseInt(idInput.value, 10),
                  quantity: 1,
                  properties: {
                    'الاسم الكامل': nameEl ? nameEl.value.trim() : '',
                    'رقم الهاتف': phoneEl ? phoneEl.value.trim() : '',
                    'العنوان': addressEl ? addressEl.value.trim() : ''
                  }
                }]
              })
            });
          })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || data.message || 'تعذّر إتمام الطلب'); });
            return res.json();
          })
          .then(function () {
            if (watchdog) clearTimeout(watchdog);
            settled = true;
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            resetButton(err.message || 'حدث خطأ، حاول مرة أخرى');
          });
      });
    }
  }

  function validateForm(form) {
    var ok = true;
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-validate]'));
    fields.forEach(function (f) {
      var input = f.querySelector('input');
      var type = f.getAttribute('data-validate');
      var val = (input && input.value || '').trim();
      var bad = false;
      if (type === 'required') bad = val.length === 0;
      if (type === 'phone') bad = !/^\d{10}$/.test(val.replace(/\D/g, ''));
      f.classList.toggle('has-error', bad);
      if (bad) ok = false;
    });
    return ok;
  }

  function initGallery() {
    var stage = document.querySelector('[data-nosee-stage]');
    if (!stage) return;
    var main = stage.querySelector('img');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-nosee-thumb]'));
    if (!thumbs.length || !main) return;

    var autoplay = stage.getAttribute('data-autoplay') === 'true';
    var speedSec = parseFloat(stage.getAttribute('data-autoplay-speed')) || 4;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function showSlide(i) {
      current = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var src = thumbs[current].getAttribute('data-src');
      if (src) main.src = src;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      thumbs[current].classList.add('is-active');
    }

    function restartTimer() {
      if (timer) clearInterval(timer);
      if (autoplay && !reducedMotion && thumbs.length > 1) {
        timer = setInterval(function () { showSlide(current + 1); }, speedSec * 1000);
      }
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        showSlide(idx);
        restartTimer();
      });
    });

    showSlide(0);
    restartTimer();
  }

  function initAccordion() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-nosee-acc]'));
    items.forEach(function (item) {
      var q = item.querySelector('.nosee-acc__q');
      var a = item.querySelector('.nosee-acc__a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (it) {
          it.classList.remove('is-open');
          var aa = it.querySelector('.nosee-acc__a');
          var qq = it.querySelector('.nosee-acc__q');
          if (aa) aa.style.maxHeight = null;
          if (qq) qq.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-nosee-sticky]');
    var anchor = document.querySelector('[data-nosee-form]') || document.querySelector('[data-nosee-offers]');
    if (!bar) return;
    var btn = bar.querySelector('[data-nosee-sticky-btn]');
    if (btn && anchor) {
      btn.addEventListener('click', function () { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    function onScroll() {
      var show = window.innerWidth <= 749 && window.scrollY > 520;
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function initCountdown() {
    var timers = Array.prototype.slice.call(document.querySelectorAll('[data-nosee-countdown]'));
    timers.forEach(startCountdown);
  }

  function pad2(n) {
    n = Math.max(0, n);
    return n < 10 ? '0' + n : String(n);
  }

  function startCountdown(el) {
    var targetStr = el.getAttribute('data-target');
    if (!targetStr) return;

    var target = new Date(targetStr.replace(' ', 'T'));
    if (isNaN(target.getTime())) return;

    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minutesEl = el.querySelector('[data-cd-minutes]');
    var secondsEl = el.querySelector('[data-cd-seconds]');

    var intervalId = null;

    function render(days, hours, minutes, seconds) {
      if (daysEl) daysEl.textContent = pad2(days);
      if (hoursEl) hoursEl.textContent = pad2(hours);
      if (minutesEl) minutesEl.textContent = pad2(minutes);
      if (secondsEl) secondsEl.textContent = pad2(seconds);
    }

    function tick() {
      var now = new Date();
      var diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        render(0, 0, 0, 0);
        if (intervalId) clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      render(days, hours, minutes, seconds);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }
})();